'use client';

import { EnthiosHubLoader } from '@/components/ui/EnthiosHubLoader';

type Props = {
  label?: string;
  compact?: boolean;
};

/** In-content loading state shown during route transitions. */
export function DashboardPageLoading({ label, compact = false }: Props) {
  return (
    <EnthiosHubLoader
      message={label}
      variant={compact ? 'inline' : 'panel'}
      showDelayMs={300}
    />
  );
}

/** Branded overlay centered in the dashboard content area during navigation. */
export function DashboardNavigationOverlay({ label }: { label?: string }) {
  return (
    <div className="dash-nav-overlay" aria-hidden={false}>
      <div className="dash-nav-overlay-card">
        <EnthiosHubLoader
          message={label}
          variant="overlay"
          showDelayMs={0}
          className="eh-loader--overlay"
        />
      </div>
    </div>
  );
}
